import React from 'react';
import { useTranslation } from 'react-i18next';
import style from './errorForm.module.scss';

function ErrorForm(props) {
  const { error, backHandle } = props;
  const { t } = useTranslation();
  return (
    <div className={style.mainWrapper}>
      <div className={style.head_wrapper}>
        <h3 className={style.header}>{t('common.errors.oops')}</h3>
        <h4 className={style.sub_header}>
          {t('common.errors.message')}: {error}
        </h4>
      </div>
      <button className={style.back_button} onClick={backHandle}>
        {t('common.general.back')}
      </button>
    </div>
  );
}

export default ErrorForm;
